import { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router";
import { ShellContext } from "@/components/shell/shell-context.tsx";
import { Sidebar } from "@/components/shell/sidebar.tsx";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet.tsx";
import { useI18n } from "@/i18n/index.tsx";
import { useIsWide } from "@/lib/hooks.ts";

/** Left sidebar (280px) on wide screens; below 1280px it becomes a drawer. */
export function AppShell() {
  const { t } = useI18n();
  const isWide = useIsWide();
  const location = useLocation();
  const [drawer, setDrawer] = useState(false);

  useEffect(() => {
    setDrawer(false);
  }, [location.pathname]);

  const shell = useMemo(() => ({ openNavigation: () => setDrawer(true) }), []);

  return (
    <ShellContext.Provider value={shell}>
      <div className="flex h-dvh overflow-hidden bg-background">
        {isWide ? (
          <aside className="flex w-[280px] shrink-0 flex-col border-r border-sidebar-border">
            <Sidebar />
          </aside>
        ) : (
          <Sheet open={drawer} onOpenChange={setDrawer}>
            <SheetContent side="left" closeLabel={t.shell.closeMenu} className="p-0" aria-describedby={undefined}>
              <SheetTitle className="sr-only">{t.shell.navigation}</SheetTitle>
              <Sidebar inDrawer />
            </SheetContent>
          </Sheet>
        )}
        <main className="flex min-w-0 flex-1 flex-col">
          <Outlet />
        </main>
      </div>
    </ShellContext.Provider>
  );
}
